// src/pages/RevizyonPlanlama.js
import React, { useState, useEffect } from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';

const RevizyonPlanlama = () => {
  const [kompresorler, setKompresorler] = useState([]);
  const [filtre, setFiltre] = useState('');
  const [revizyonLimiti, setRevizyonLimiti] = useState(20000); // Örn: 20000 saat

  useEffect(() => {
    const veriler = JSON.parse(localStorage.getItem('kompresorKayitlari')) || [];
    setKompresorler(veriler);
  }, []);

  const filtreli = kompresorler.filter(
    (item) =>
      (item.firma?.toLowerCase().includes(filtre.toLowerCase()) ||
        item.model?.toLowerCase().includes(filtre.toLowerCase()) ||
        item.seriNo?.toLowerCase().includes(filtre.toLowerCase())) &&
      parseInt(item.toplamSaat || 0) >= revizyonLimiti
  );

  return (
    <div className="max-w-6xl mx-auto p-4">
      <Card>
        <CardContent className="space-y-4">
          <h2 className="text-2xl font-bold">♻️ Revizyon Planlama</h2>

          <div className="flex flex-wrap gap-4">
            <Input
              placeholder="Firma, model, seri no ile ara"
              value={filtre}
              onChange={(e) => setFiltre(e.target.value)}
            />
            <Input
              type="number"
              placeholder="Revizyon saati limiti (örneğin: 20000)"
              value={revizyonLimiti}
              onChange={(e) => setRevizyonLimiti(parseInt(e.target.value) || 0)}
            />
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
            {filtreli.map((k, i) => (
              <div key={i} className="border p-4 rounded shadow bg-white">
                <p><strong>Firma:</strong> {k.firma}</p>
                <p><strong>Model:</strong> {k.model}</p>
                <p><strong>Seri No:</strong> {k.seriNo}</p>
                <p><strong>Toplam Çalışma Saati:</strong> {k.toplamSaat}</p>
                <p className="text-red-600 font-semibold">⚠️ Revizyon zamanı yaklaşmış</p>
              </div>
            ))}

            {filtreli.length === 0 && <p className="text-gray-500">Uygun kriterde revizyonluk kayıt bulunamadı.</p>}
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default RevizyonPlanlama;